"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlanResultCacheManager = void 0;
class PlanResultCacheManager {
    #planParamsOperationsManager;
    #serviceReferenceManager;
    constructor(planParamsOperationsManager, serviceReferenceManager) {
        this.#planParamsOperationsManager = planParamsOperationsManager;
        this.#serviceReferenceManager = serviceReferenceManager;
    }
    invalidateService(invalidation) {
        this.#serviceReferenceManager.planResultCacheService.invalidateServiceBinding({
            ...invalidation,
            operations: this.#planParamsOperationsManager.planParamsOperations,
        });
    }
}
exports.PlanResultCacheManager = PlanResultCacheManager;
//# sourceMappingURL=PlanResultCacheManager.js.map